import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/marketing/social')({
  component: () => <PageStub title="Social Media" description="Social media planning and scheduling" />,
});
